import { Platform, useWindowDimensions } from 'react-native';
import { gabaritPour, type Gabarit } from '../theme/gabarit';

export interface InfosGabarit {
  gabarit: Gabarit;
  /** Largeur de la fenêtre, en pixels. */
  largeur: number;
  compact: boolean;
  moyen: boolean;
  etendu: boolean;
  /** Tout ce qui n'est pas le téléphone : moyen ou étendu. */
  large: boolean;
}

/**
 * Gabarit courant, réactif : redimensionner la fenêtre d'un navigateur ou tourner une tablette met
 * à jour la disposition sans recharger. (Les tailles de texte et d'espacement, elles, sont figées
 * au chargement : voir `tokens.ts`.) Hors du web, toujours `compact` : voir `gabaritPour`.
 */
export function useGabarit(): InfosGabarit {
  const { width } = useWindowDimensions();
  const gabarit = gabaritPour(width, Platform.OS === 'web');
  return {
    gabarit,
    largeur: width,
    compact: gabarit === 'compact',
    moyen: gabarit === 'moyen',
    etendu: gabarit === 'etendu',
    large: gabarit !== 'compact',
  };
}
